'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialAtCircular = function TiSocialAtCircular(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.7 12.5c-4.1 0-7.4 3.4-7.4 7.5s3.5 7.5 7.6 7.5c1.5 0 3-0.4 4.2-1.3 0.4-0.3 0.5-0.8 0.3-1.2-0.3-0.3-0.8-0.4-1.2-0.2-0.9 0.7-2.1 1-3.3 1-3.2 0-5.8-2.6-5.8-5.8s2.4-5.8 5.6-5.8 5.7 2.6 5.7 5.8v0.4c0 0.7-0.6 1.3-1.3 1.3s-1.2-0.6-1.2-1.3v-2.9c0-0.5-0.2-0.8-0.7-0.8-0.3 0-0.5 0.2-0.6 0.5-0.5-0.3-1.1-0.5-1.7-0.5-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3c1 0 1.8-0.4 2.4-1 0.6 0.6 1.1 1 2 1 1.6 0 2.7-1.3 2.7-2.9v-0.4c0-4.1-3.1-7.5-7.3-7.5z m0.2 9.2c-0.9 0-1.6-0.8-1.6-1.7s0.7-1.7 1.6-1.7 1.7 0.8 1.7 1.7-0.7 1.7-1.7 1.7z m0.1 13.3c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z m0-26.7c-6.4 0-11.7 5.3-11.7 11.7s5.3 11.7 11.7 11.7 11.7-5.3 11.7-11.7-5.3-11.7-11.7-11.7z' })
        )
    );
};

exports.default = TiSocialAtCircular;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-at-circular.js
// module id = 2168
// module chunks = 0